import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../actions/locationActions';
import Drawer from '../Common/Drawer/Drawer';
import LocationUserAccessForm from './LocationUserAccessForm';
import Notification from '../Common/Notification';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import * as types from '../../constants/actionTypes';

export class LocationUserAccessDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isFormValid: true,
            isLoading: false,
            name: '',
            usersWithManualAccess: [],
            usersWithAccessByRule: [],
            availableUsers: []
        };
    }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });
            const response = await this.props.actions.loadLocationUserAccess(
                this.props.subscriptionId,
                this.props.locationId
            );
            if (response.type === types.LOAD_LOCATION_USER_ACCESS_SUCCESS) {
                const usersWithManualAccess = response.payload.usersWithManualAccess;
                const usersWithAccessByRule = response.payload.usersWithAccessByRule;
                const totalUsersWithAccess = [...usersWithManualAccess, ...usersWithAccessByRule];
                const availableUsers = response.payload.availableUsers.filter(a => totalUsersWithAccess.findIndex((x) => x.id === a.id) < 0 )
                this.setState({
                    name: response.payload.name,
                    usersWithManualAccess,
                    usersWithAccessByRule,
                    availableUsers
                });
            } else if (response.type === types.LOAD_LOCATION_USER_ACCESS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onCancel = () => {
        this.setState({ isFormValid: true });
        this.props.onCancel();
    }

    onSave = async () => {
        try {
            this.setState({ isLoading: true });
            const request = {
                subscriptionId: this.props.subscriptionId,
                id: this.props.locationId,
                userIds: this.state.usersWithManualAccess.map(u => u.id)
            }
            const response = await this.props.actions.saveLocationUserAccess(request);
            if (response.type === types.SAVE_LOCATION_USER_ACCESS_SUCCESS) {
                Notification("success", "Success", "User Access updated successfully");
                this.setState({ isFormValid: true });
                this.props.onComplete();
            } else if (response.type === types.SAVE_LOCATION_USER_ACCESS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false });
        }
    }

    // Add user to user list and remove from available user list
    addUser = (option) => {
        let users = this.state.usersWithManualAccess.slice();
        let availableUsers = this.state.availableUsers.slice();

        const existingUser = users.find(x => x.id === option.id);
        if (existingUser === undefined) {
            users.push(option);
        }
        const availableUserIndex = availableUsers.findIndex(x => x.id === option.id);
        if (availableUserIndex >= 0) {
            availableUsers.splice(availableUserIndex, 1);
        }
        this.setState({ usersWithManualAccess: users, availableUsers: availableUsers });
    }

    // Remove user from user list and add to available user list
    removeUser = (option) => {
        let users = this.state.usersWithManualAccess.slice();
        let availableUsers = this.state.availableUsers.slice();

        const existingUserIndex = users.findIndex(x => x.id === option.id);
        if (existingUserIndex >= 0) {
            users.splice(existingUserIndex, 1);
        }

        const availableUser = availableUsers.find(x => x.id === option.id);
        if (availableUser === undefined) {
            availableUsers.push(option);
            // Sort by name again, so the available users are always sorted
            availableUsers.sort((a, b) => a.name == b.name ? 0 : a.name > b.name ? 1 : -1)
        }
        this.setState({ usersWithManualAccess: users, availableUsers: availableUsers });
    }

    render() {
        const title = 'User Access';

        return (
            <Drawer isWide={false} title={title}
                onSaveClick={this.onSave}
                onCancelClick={this.onCancel}
                menuButtons={this.props.menuButtons}
                currentDrawerKey={this.props.currentDrawerKey} >
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <LocationUserAccessForm
                        locationName={this.state.name}
                        usersWithManualAccess={this.state.usersWithManualAccess}
                        usersWithAccessByRule={this.state.usersWithAccessByRule}
                        isFormValid={this.state.isFormValid}
                        availableUsers={this.state.availableUsers}
                        addUser={this.addUser}
                        removeUser={this.removeUser}
                    />
                </LoadingIndicator>
            </Drawer>
        )
    }
}

LocationUserAccessDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    locationId: PropTypes.number,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    menuButtons: PropTypes.array.isRequired,
    currentDrawerKey: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

export default connect(null, mapDispatchToProps)(LocationUserAccessDrawer);
